import React from 'react'
import { firstCharCapitalize } from '../utils/utils'
import './ProductoDetalleHeader.scss'

export const ProductoDetalleHeader = ({ product, nombre, descuento, productsTable }) => {

    return (
        <div className="producto-detalle-header">
            <div className="l1"><p>{product.Categoria} | {product.Coleccion}</p></div>
            <div className="l2"><p>{firstCharCapitalize(nombre)}
                {product.Descuento !== undefined && product.Descuento !== null && product.Descuento !== '-' && product.Descuento !== '' &&
                    <span>- {descuento}</span>
                }</p>
            </div>
            {product.Estado === 'NUEVO' || product.Estado === 'PROXIMAMENTE' &&
                <div className="l1 nuevo"><p><span>NUEVO</span></p></div>
            }
        </div>
    )
}